import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
  Checkbox,
  Fade,
  Popover,
  List,
  ListItem,
  Chip,
  Switch
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { useQuery } from 'src/app/hooks/useQuery';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { MESSAGE } from 'src/app/constant/message';
import { closeDialogConfirm, showDialogConfirm, showGlobalToast } from 'src/features/uiSlice';
import { messageToastType_const } from 'src/app/constant/config';
import { useDispatch } from 'react-redux';
import { deleteGeocodeSource } from 'src/features/geocodeSlice';
import EditGeocodeSource from './EditGeocodeSource';
import axios from 'src/app/axiosInterceptor';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    whiteSpace: 'nowrap'
  },
  root: {
    padding: '12px 16px'
  }
}))(TableCell);

const Results = ({
  className,
  listSources,
  supportedTypes,
  getListSourcesRef,
  currentParams
}) => {
  const classes = useStyles();
  const [limit] = useState(PAGE_SIZE_LIST);
  const [page, setPage] = useState(1);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [itemCurrent, setItemCurrent] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [params, setParams] = useState({
    page: page,
    page_size: limit
  });
  const dispatch = useDispatch();
  const query = useQuery();

  useEffect(() => {
    if (currentParams) {
      setParams({
        ...currentParams,
        page: currentParams?.page || 1,
        page_size: currentParams?.page_size || PAGE_SIZE_LIST
      });
    }
  }, [currentParams]);

  useEffect(() => {
    const pageFromQuery = query.get('page');
    const pageSizeFromQuery = query.get('page_size');

    if (pageFromQuery) {
      setParams(prev => ({
        ...prev,
        page: Number(pageFromQuery)
      }));
    }
    if (pageSizeFromQuery) {
      setParams(prev => ({
        ...prev,
        page_size: Number(pageSizeFromQuery)
      }));
    }
  }, [query]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListSourcesRef) return;
    const newParams = {
      ...currentParams,
      page: newPage,
      page_size: limit
    };
    setParams(newParams);
    getListSourcesRef(newParams);
  };

  const checked = id => {
    return rowsSelected.indexOf(id) !== -1;
  };

  const select = id => {
    if (rowsSelected.indexOf(id) === -1) {
      const newSelected = [id, ...rowsSelected];
      setRowsSelected(newSelected);
    } else {
      const newSelected = rowsSelected.filter(i => i !== id);
      setRowsSelected(newSelected);
    }
  };

  const checkAll = () => {
    if (rowsSelected.length > 0) {
      setRowsSelected([]);
    }

    if (
      listSources.length > 0 &&
      rowsSelected.length !== listSources.length
    ) {
      const all = listSources.map(item => {
        return item.id;
      });
      setRowsSelected(all);
    }
  };

  const handleClickMenu = (event, source) => {
    setAnchorEl(event.currentTarget);
    setItemCurrent(source);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDeleteSource = () => {
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleEditSource = () => {
    setOpenEditModal(true);
    handleCloseMenu();
  };

  const handleTestSource = () => {
    handleCloseMenu();
    if (!itemCurrent) return;

    const testBody = {
      type: itemCurrent.type,
      url: itemCurrent.url,
      api_key: itemCurrent.api_key || '',
      api_key_param: itemCurrent.api_key_param || '',
      lat: 21.028511,
      lng: 105.804817
    };

    axios.post('/geocode/sources/test', testBody)
      .then(res => {
        const data = res.data;
        if (data.success && data.payload) {
          dispatch(showGlobalToast({
            message: `Test OK: ${data.payload.address || data.payload.display_name || ''} (${data.payload.duration_ms || '?'}ms)`,
            type: messageToastType_const.success
          }));
        } else {
          dispatch(showGlobalToast({
            message: data.message || 'Test thất bại',
            type: messageToastType_const.error
          }));
        }
      })
      .catch(err => {
        dispatch(showGlobalToast({
          message: 'Test thất bại: ' + (err?.data?.message || err?.message || 'Lỗi không xác định'),
          type: messageToastType_const.error
        }));
      });
  };

  const confirmDelete = () => {
    setRowsSelected([]);
    dispatch(closeDialogConfirm());
    dispatch(deleteGeocodeSource({ id: itemCurrent.id }));
  };

  const closeEditModal = () => {
    setOpenEditModal(false);
    setItemCurrent(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <DialogConfirm
        title={MESSAGE.CONFIRM_DELETE_GEOCODE_SOURCE}
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={MESSAGE.CONTENT_DELETE_GEOCODE_SOURCE}
        callbackOk={() => confirmDelete()}
        callbackCancel={() => dispatch(closeDialogConfirm())}
      />
      {openEditModal && (
        <EditGeocodeSource
          open={openEditModal}
          onClose={closeEditModal}
          sourceData={itemCurrent}
          supportedTypes={supportedTypes}
        />
      )}
      <Card className={clsx(classes.root, className)}>
        <div>
          {rowsSelected.length > 0 && (
            <Fade in={rowsSelected.length > 0}>
              <Box
                minWidth={1050}
                style={{ fontSize: '14px', padding: '12px 16px' }}
              >
                <span>
                  <Checkbox
                    checked={rowsSelected.length > 0}
                    onChange={() => checkAll()}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                </span>
              </Box>
            </Fade>
          )}
          <PerfectScrollbar>
            {listSources && listSources.length ? (
              <Box minWidth={1050}>
                <Table>
                  {listSources?.length > 0 && rowsSelected.length === 0 && (
                    <TableHead>
                      <TableRow>
                        <StyledTableCell style={{ width: '5%' }}>
                          <Checkbox
                            checked={rowsSelected.length > 0}
                            onChange={() => checkAll()}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '15%' }}>
                          Tên nguồn
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '10%' }}>
                          Loại
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '20%' }}>
                          URL
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '8%' }}>
                          Độ ưu tiên
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '8%' }}>
                          Kích hoạt
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '10%' }}>
                          Giới hạn (req/s)
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ width: '10%' }}
                        ></StyledTableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {listSources.map(source => (
                      <TableRow hover key={source.id}>
                        <StyledTableCell
                          style={{ maxWidth: '30px' }}
                          onClick={() => select(source?.id)}
                        >
                          <Checkbox
                            checked={checked(source?.id)}
                            onChange={() => select(source?.id)}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          {source?.name || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Chip
                            size="small"
                            label={source?.type || '-'}
                            style={{ fontWeight: 500 }}
                          />
                        </StyledTableCell>
                        <StyledTableCell style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {source?.url || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {source?.priority ?? '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Switch
                            checked={source?.enabled || false}
                            size="small"
                            disabled
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          {source?.rate_limit_per_sec || 0}
                        </StyledTableCell>
                        <StyledTableCell>
                          <span style={{ color: '#AEB1C5' }}>
                            <MoreVertIcon
                              aria-describedby={`menu-geocode-${source.id}`}
                              className={`cursor-pointer hover-red`}
                              onClick={e => handleClickMenu(e, source)}
                            />
                          </span>

                          <Popover
                            id={`menu-geocode-${source.id}`}
                            className="popover-device"
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleCloseMenu}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left'
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'right'
                            }}
                          >
                            <Typography>
                              <List>
                                <ListItem
                                  className="border-bottom list-menu-device cursor-pointer"
                                  onClick={handleEditSource}
                                >
                                  Chỉnh sửa
                                </ListItem>
                                <ListItem
                                  className="border-bottom list-menu-device cursor-pointer"
                                  onClick={handleTestSource}
                                >
                                  Test
                                </ListItem>
                                <ListItem
                                  className="cursor-pointer list-menu-device"
                                  onClick={handleDeleteSource}
                                >
                                  <span className="text-danger"> Xóa </span>
                                </ListItem>
                              </List>
                            </Typography>
                          </Popover>
                        </StyledTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            ) : (
              <div className="text-center pb-5">
                <img src="/static/empty.png" alt="" class="justify-content-center" />
                <h4> Danh sách trống </h4>
              </div>
            )}
          </PerfectScrollbar>
        </div>
      </Card>
      {listSources && listSources.length > 0 && (
        <div class="mt-3 mr-[16px] float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {listSources.length}
            </Typography>
            <Pagination
              count={Math.ceil(listSources.length / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page)}
              showFirstButton
              showLastButton
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listSources: PropTypes.array.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default React.memo(Results);